/* Benign COD order form - storefront script. ES5 only. No dependencies.
   Loaded via sections/footer-group.json custom liquid. Reads:
     window.COD_API      - backend base URL
     window.COD_SHOP     - store code sent as "shop"
     window.COD_PRODUCT  - {handle,title,image,variants:[{id,title,price,compare_at_price,available}]} (paise)
     window.COD_I18N     - {current, langs:[{iso_code,endonym_name,root_url,primary}]}
*/
(function () {
  'use strict';
  if (window.__codFormLoaded) { return; }
  window.__codFormLoaded = true;

  var API = window.COD_API || '';
  var SHOP = window.COD_SHOP || '';
  var P = window.COD_PRODUCT || null;
  var I18N = window.COD_I18N || null;
  var LS_KEY = 'cod_form_v1';
  var DEVICE_KEY = 'cod_device_v1';
  var OUTBOX_KEY = 'cod_outbox_v1';
  var LAST_ORDER_KEY = 'cod_last_order_v1';
  var MAX_QTY = 3;
  var cfg = {
    btnGradientStart: '#c9a227', btnGradientEnd: '#a8861a', btnText: '#0a0a0a', accent: '#c9a227',
    cta: 'Order Now - Free COD & Shipping', ctaSub: '120-Day Money Back Guarantee', ctaForm: 'Complete My Purchase - {total}',
    trustLine: 'FREE & EASY 120-DAY RETURNS/REFUNDS', timerMinutes: 30, timerText: 'Hurry! Bundle offer ends in',
    maxQty: 3, pixels: [], snapPixels: [], repeatBlockDays: 90, repeatBlockMessage: '', downsellAmount: 0, downsellCode: ''
  };
  var state = { open: false, variantId: null, qty: 1, submitting: false, openedAt: 0, pinOk: null, submitId: null, discountCode: null, downsellShown: false, downsellUsed: false, tick: null, done: false };
  var els = {};

  /* ---------------- utils ---------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, cap) { if (el) { el.addEventListener(ev, fn, !!cap); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(paise) {
    var r = Math.round(paise) / 100; var s = r.toFixed(r % 1 === 0 ? 0 : 2);
    var parts = s.split('.'); var x = parts[0]; var last3 = x.slice(-3); var rest = x.slice(0, -3);
    if (rest) { last3 = ',' + last3; }
    return '₹' + rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + last3 + (parts[1] ? '.' + parts[1] : '');
  }
  function lsGet(k) { try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { } }
  function uid() { return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  function deviceId() { var d = lsGet(DEVICE_KEY); if (!d) { d = uid() + uid(); lsSet(DEVICE_KEY, d); } return d; }
  function xhr(method, url, body, cb, timeoutMs) {
    var x = new XMLHttpRequest(); var done = false;
    x.open(method, url, true); x.timeout = timeoutMs || 20000;
    if (body) { x.setRequestHeader('Content-Type', 'application/json'); }
    x.onreadystatechange = function () {
      if (x.readyState !== 4 || done) { return; } done = true;
      var j = null; try { j = JSON.parse(x.responseText); } catch (e) { }
      cb(x.status, j);
    };
    x.ontimeout = function () { if (!done) { done = true; cb(0, null); } };
    x.onerror = function () { if (!done) { done = true; cb(0, null); } };
    x.send(body ? JSON.stringify(body) : null);
  }
  function getUtm() {
    var out = {}; var q = window.location.search.replace(/^\?/, '').split('&');
    for (var i = 0; i < q.length; i++) { var kv = q[i].split('='); if (/^utm_/.test(kv[0])) { try { out[kv[0]] = decodeURIComponent(kv[1] || ''); } catch (e) { } } }
    var saved = lsGet('cod_utm'); if (Object.keys(out).length) { lsSet('cod_utm', out); return out; }
    return saved || {};
  }
  function getScCid() {
    var m = /[?&]ScCid=([^&#]+)/i.exec(window.location.search);
    if (m) { try { var v = decodeURIComponent(m[1]); lsSet('cod_sccid', { v: v, ts: Date.now() }); return v; } catch (e) { } }
    var saved = lsGet('cod_sccid'); return (saved && saved.v && (Date.now() - saved.ts) < 28 * 86400000) ? saved.v : '';
  }
  function isAscii(s) { return /^[\x20-\x7E]*$/.test(s); }
  function cookie(name) { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------------- Meta + Snap pixels (browser side; server sends the matching CAPI Purchase) ---------------- */
  var pixelsReady = false;
  var SNAP_EVENT = { ViewContent: 'VIEW_CONTENT', InitiateCheckout: 'START_CHECKOUT', Purchase: 'PURCHASE' };
  function loadSnap(extra) {
    var ids = cfg.snapPixels || []; if (!ids.length) { return; }
    if (!window.snaptr) {
      (function (e, t, n) { if (e.snaptr) { return; } var a = e.snaptr = function () { a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments); };
        a.queue = []; var s = 'script'; var r = t.createElement(s); r.async = true; r.src = n; var u = t.getElementsByTagName(s)[0]; u.parentNode.insertBefore(r, u); })(window, document, 'https://sc-static.net/scevent.min.js');
    }
    for (var i = 0; i < ids.length; i++) { try { window.snaptr('init', String(ids[i]), extra || {}); } catch (e) { } }
  }
  function snapData(d, eventId) {
    var out = { currency: d.currency, price: d.value, item_ids: d.content_ids, item_category: 'product', number_items: d.num_items, description: d.content_name };
    if (eventId) { out.client_dedup_id = eventId; }
    if (d.order_id) { out.transaction_id = d.order_id; }
    return out;
  }
  function loadPixels() {
    var ids = cfg.pixels || []; if (pixelsReady) { return; } pixelsReady = true;
    loadSnap();
    if (!ids.length) { return; }
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) { if (f.fbq) { return; } n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) { f._fbq = n; } n.push = n; n.loaded = true; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = true; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    for (var i = 0; i < ids.length; i++) { try { window.fbq('init', String(ids[i])); } catch (e) { } }
  }
  function track(name, data, eventId) {
    var ids = cfg.pixels || [];
    if (ids.length && window.fbq) {
      for (var i = 0; i < ids.length; i++) {
        try { window.fbq('trackSingle', String(ids[i]), name, data || {}, eventId ? { eventID: eventId } : undefined); } catch (e) { }
      }
    }
    if ((cfg.snapPixels || []).length && window.snaptr && SNAP_EVENT[name]) {
      try { window.snaptr('track', SNAP_EVENT[name], snapData(data || {}, eventId)); } catch (e) { }
    }
  }
  function contentData() {
    var v = currentVariant(); if (!v) { return {}; }
    var qty = isTiered() ? 1 : state.qty;
    return { content_type: 'product', content_ids: [String(v.id)], content_name: P.title, currency: 'INR', value: totals().total / 100,
      contents: [{ id: String(v.id), quantity: qty, item_price: v.price / 100 }], num_items: qty };
  }

  /* ---------------- variant / pricing (display only; server re-prices) ---------------- */
  function variants() { return (P && P.variants) ? P.variants : []; }
  function currentVariant() {
    var vs = variants(); for (var i = 0; i < vs.length; i++) { if (String(vs[i].id) === String(state.variantId)) { return vs[i]; } }
    return vs[0] || null;
  }
  function isTiered() { return variants().length > 1; }
  function readThemeVariant() {
    var inp = $('form[action*="/cart/add"] input[name="id"]'); if (inp && inp.value) { state.variantId = inp.value; }
    var m = /[?&]variant=(\d+)/.exec(window.location.search); if (!state.variantId && m) { state.variantId = m[1]; }
    if (!state.variantId && variants()[0]) { state.variantId = variants()[0].id; }
  }
  function totals() {
    var v = currentVariant(); if (!v) { return { subtotal: 0, discount: 0, total: 0, compare: 0, save: 0 }; }
    var qty = isTiered() ? 1 : state.qty;
    var sub = v.price * qty; var cmp = (v.compare_at_price || 0) * qty;
    var disc = state.discountCode ? Math.min((cfg.downsellAmount || 0) * 100, sub - 100) : 0;
    if (disc < 0) { disc = 0; }
    return { subtotal: sub, discount: disc, total: sub - disc, compare: cmp > sub ? cmp : 0, save: cmp > sub ? cmp - sub : 0 };
  }

  /* ---------------- icons ---------------- */
  var ICON = {
    cart: '<path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M6 6L5 3H2"/>',
    name: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/>',
    phone: '<rect x="7" y="2" width="10" height="20" rx="2"/><path d="M11 18h2"/>',
    address1: '<path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-6h4v6"/>',
    address2: '<path d="M12 22s7-6 7-12a7 7 0 0 0-14 0c0 6 7 12 7 12z"/><circle cx="12" cy="10" r="2.5"/>',
    pincode: '<path d="M5 9h14M5 15h14M10 3L8 21M16 3l-2 18"/>',
    city: '<path d="M4 21V9l8-5 8 5v12"/><path d="M9 21v-6h6v6"/><path d="M9 12h.01M15 12h.01"/>',
    state: '<path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z"/><path d="M9 4v14M15 6v14"/>'
  };
  function svg(name, cls) { return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICON[name] + '</svg>'; }

  /* ---------------- styles ---------------- */
  function injectStyles() {
    var a = cfg.accent, g1 = cfg.btnGradientStart, g2 = cfg.btnGradientEnd, bt = cfg.btnText;
    var css = ''
      + ':root{--codf-btn-from:' + g1 + ';--codf-btn-to:' + g2 + ';--codf-btn-text:' + bt + ';--codf-accent:' + a + '}'
      + '.codf-hide{display:none!important}'
      + '.codf-btn{display:block;width:100%;border:0;cursor:pointer;margin:10px 0;padding:14px 16px;border-radius:19px;color:var(--codf-btn-text);font-weight:700;font-size:16px;line-height:1.2;text-align:center;background:linear-gradient(180deg,var(--codf-btn-from) 0%,var(--codf-btn-to) 100%);box-shadow:0 6px 16px rgba(0,0,0,.18);animation:codf-tada 2.2s infinite;font-family:inherit}'
      + '.codf-btn small{display:block;font-weight:500;font-size:12px;opacity:.95;margin-top:3px}'
      + '.codf-btn .codf-ico{display:inline-block;width:18px;height:18px;vertical-align:-3px;margin-right:6px}'
      + '@keyframes codf-tada{0%,88%,100%{transform:scale(1)}90%{transform:scale(.96) rotate(-1deg)}94%{transform:scale(1.04) rotate(1deg)}97%{transform:scale(1.02) rotate(-1deg)}}'
      + '.codf-ov{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);z-index:2147483000;display:none;align-items:flex-start;justify-content:center;overflow:auto;-webkit-overflow-scrolling:touch}'
      + '.codf-ov.on{display:flex}'
      + '.codf-m{background:#fff;color:#000;width:100%;max-width:520px;min-height:100%;padding:14px 16px 28px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;font-size:15px;line-height:1.35;position:relative;box-sizing:border-box}'
      + '@media(min-width:768px){.codf-ov{align-items:center;padding:24px}.codf-m{min-height:0;border-radius:10px;max-height:92vh;overflow:auto}}'
      + '.codf-x{position:absolute;right:10px;top:8px;width:36px;height:36px;border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer;color:#333}'
      + '.codf-prod{display:flex;gap:12px;align-items:center;margin:8px 36px 12px 0}'
      + '.codf-prod img{width:64px;height:64px;object-fit:cover;border-radius:8px;background:#f3f3f3}'
      + '.codf-prod .t{flex:1;font-weight:600;text-decoration:underline}.codf-prod .v{font-weight:400;font-size:13px;color:#555;text-decoration:none}.codf-prod .p{font-weight:700;white-space:nowrap}'
      + '.codf-tiers{display:flex;flex-direction:column;gap:8px;margin:10px 0}'
      + '.codf-tier{display:flex;justify-content:space-between;align-items:center;padding:11px 14px;border:2px solid #cfcfcf;border-radius:10px;background:#fff;cursor:pointer}'
      + '.codf-tier.on{border-color:var(--codf-btn-to);background:#fffdf5;box-shadow:0 0 0 1px var(--codf-btn-to) inset}'
      + '.codf-tier b{font-size:15px}.codf-tier small{display:block;font-size:12px;color:var(--codf-accent);font-weight:600}.codf-tier s{color:#777;font-size:12px;display:block;text-align:right}'
      + '.codf-badge{font-size:10px;background:linear-gradient(135deg,#ff9c00 0%,#ff144d 72%);color:#fff;padding:2px 7px;border-radius:20px;font-weight:700;text-transform:uppercase;margin-left:6px;vertical-align:middle}'
      + '.codf-qty{display:inline-flex;border:1px solid #ccc;border-radius:8px;overflow:hidden;margin-left:8px;vertical-align:middle}'
      + '.codf-qty button{width:30px;border:0;background:#f5f5f5;font-size:18px;cursor:pointer}.codf-qty span{min-width:28px;text-align:center;line-height:30px;font-weight:600}'
      + '.codf-sum{background:#f6f6f6;border-radius:8px;padding:10px 12px;margin:10px 0}.codf-sum div{display:flex;justify-content:space-between;padding:3px 0}'
      + '.codf-sum .tot{font-weight:800;font-size:18px;border-top:1px solid #ddd;margin-top:4px;padding-top:8px}.codf-sum .save{color:#2e7d32;font-weight:600}.codf-sum s{color:#777;font-weight:500}'
      + '.codf-h{font-weight:600;font-size:clamp(11px,3.6vw,17px);white-space:nowrap;text-align:center;margin:10px 0}'
      + '.codf-timer{border:1px solid #ffacac;background:#fdf6f6;border-radius:10px;padding:10px;text-align:center;color:#d32f2f;font-weight:700;font-size:20px;margin:10px 0}'
      + '.codf-f{margin:12px 0 0}.codf-f label{display:block;font-weight:700;margin-bottom:5px}.codf-f label i{color:#d00;font-style:normal}'
      + '.codf-f .h{font-size:12px;color:#6b7280;margin:-2px 0 6px;font-weight:400}'
      + '.codf-in{position:relative}.codf-fi{position:absolute;left:12px;top:50%;width:20px;height:20px;margin-top:-10px;color:#6b7280;pointer-events:none}'
      + '.codf-f input{width:100%;box-sizing:border-box;padding:13px 12px 13px 40px;border:2px solid #cfcfcf;border-radius:8px;font-size:16px;background:#fff;color:#000;-webkit-appearance:none;appearance:none;font-family:inherit}'
      + '.codf-f input:focus{outline:0;border-color:var(--codf-btn-to)}.codf-f input[readonly]{background:#f3f4f6;color:#374151;-webkit-text-fill-color:#374151}'
      + '.codf-f input::placeholder{color:#6b7280!important;opacity:1!important;-webkit-text-fill-color:#6b7280}.codf-f input::-webkit-input-placeholder{color:#6b7280!important;opacity:1!important;-webkit-text-fill-color:#6b7280}.codf-f input::-moz-placeholder{color:#6b7280!important;opacity:1!important}'
      + '.codf-f input{-webkit-text-fill-color:#000}.codf-f input:-webkit-autofill{-webkit-text-fill-color:#000;-webkit-box-shadow:0 0 0 1000px #fff inset}'
      + '.codf-m,.codf-m *{text-shadow:none}'
      + '.codf-f.err input{border-color:#d00}.codf-f .e{display:none;color:#d00;font-size:13px;margin-top:4px}.codf-f.err .e{display:block}'
      + '.codf-f .ok{display:none;color:#2e7d32;font-size:13px;font-weight:600;margin-top:5px}.codf-f.good .ok{display:block}'
      + '.codf-hp{position:absolute;left:-9999px;top:-9999px;height:0;width:0;opacity:0}'
      + '.codf-cta{display:block;width:100%;border:0;cursor:pointer;margin:16px 0 6px;padding:16px;border-radius:999px;color:var(--codf-btn-text);font-weight:700;font-size:17px;background:linear-gradient(180deg,var(--codf-btn-from) 0%,var(--codf-btn-to) 100%);box-shadow:0 6px 16px rgba(0,0,0,.18);font-family:inherit}'
      + '.codf-cta[disabled]{opacity:.6;cursor:wait}'
      + '.codf-alert{background:#fdecea;color:#b71c1c;border-radius:8px;padding:10px 12px;margin:10px 0;display:none}'
      + '.codf-info{background:#fff8e1;border:1px solid var(--codf-btn-to);color:#5d4a00;border-radius:8px;padding:10px 12px;margin:10px 0;font-size:13px;font-weight:600}'
      + '.codf-ty{padding:6px 0}.codf-ty h3,.codf-ty h4{margin:8px 0}.codf-ty ul{padding-left:20px}.codf-ty p{margin:8px 0}'
      + '.codf-ds{text-align:center;padding:10px 4px}'
      + '.codf-ds .badge{display:inline-block;background:linear-gradient(135deg,#ff9c00 0%,#ff144d 72%);color:#fff;border-radius:40px;min-width:74px;padding:0 14px;height:74px;line-height:74px;font-size:22px;font-weight:800;margin-bottom:10px;box-sizing:border-box}'
      + '.codf-ds h3{font-size:24px;margin:6px 0}.codf-ds p{margin:6px 0}'
      + '.codf-ds .ok{display:block;width:100%;border:0;border-radius:6px;padding:14px;color:#fff;font-weight:700;font-size:16px;background:linear-gradient(315deg,#ff9c00 0%,#ff144d 72%);cursor:pointer;margin-top:12px}'
      + '.codf-ds .no{display:block;width:100%;border:2px solid #000;border-radius:6px;padding:12px;background:#fff;font-weight:600;cursor:pointer;margin-top:10px;color:#000}'
      + 'body.codf-lock{overflow:hidden}'
      + '.codf-sticky{position:fixed;left:0;right:0;bottom:0;z-index:2147482000;padding:8px 12px calc(8px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -4px 16px rgba(0,0,0,.15);display:none;color:#000}'
      + '.codf-sticky.on{display:block}.codf-sticky .codf-btn{margin:0;animation:none}'
      + '.codf-sticky .codf-sp{display:flex;justify-content:space-between;align-items:center;font-size:13px;margin-bottom:6px;gap:10px}.codf-sticky .codf-sp b{font-size:15px;white-space:nowrap}'
      + '.codf-lang{display:flex;align-items:center;gap:8px;margin:0 0 12px;padding:9px 12px;border:2px solid var(--codf-btn-to);border-radius:12px;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.07)}'
      + '.codf-lang svg{width:20px;height:20px;flex:0 0 auto;color:var(--codf-btn-to)}'
      + '.codf-lang select{flex:1;min-width:0;border:0;background:transparent;font-size:15px;font-weight:700;color:#111;padding:2px 0;-webkit-appearance:none;appearance:none;cursor:pointer}.codf-lang select:focus{outline:0}'
      + '@media(max-width:480px){.codf-lang{padding:8px 10px}.codf-lang select{font-size:14px}}';
    var st = document.createElement('style'); st.id = 'cod-style'; st.appendChild(document.createTextNode(css));
    document.head.appendChild(st);
  }

  /* ---------------- i18n (switcher on the page, above the product title) ---------------- */
  function langSwitcher() {
    if (!I18N || !I18N.langs || I18N.langs.length < 2 || $('.codf-lang')) { return; }
    var wrap = document.createElement('div'); wrap.className = 'codf-lang';
    var h = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg><select aria-label="Language">';
    for (var i = 0; i < I18N.langs.length; i++) {
      var l = I18N.langs[i];
      h += '<option value="' + esc(l.root_url) + '"' + (l.iso_code === I18N.current ? ' selected' : '') + '>' + esc(l.endonym_name) + '</option>';
    }
    wrap.innerHTML = h + '</select>';
    on($('select', wrap), 'change', function (e) {
      var root = e.target.value.replace(/\/$/, ''); var path = window.location.pathname;
      for (var j = 0; j < I18N.langs.length; j++) { var r = I18N.langs[j].root_url.replace(/\/$/, ''); if (r && path.indexOf(r + '/') === 0) { path = path.slice(r.length); } }
      window.location.href = root + path + window.location.search;
    });
    var title = $('.product__title, product-information h1, .shopify-section h1, h1');
    if (title && title.parentNode) { title.parentNode.insertBefore(wrap, title); }
  }

  /* ---------------- modal markup ---------------- */
  var HINT = {
    name: 'अपना पूरा नाम English अक्षरों में लिखें',
    phone: '10 अंकों का मोबाइल नंबर (6, 7, 8 या 9 से शुरू)',
    address1: 'मकान नं., बिल्डिंग / कॉलोनी — English में लिखें',
    address2: 'गली, सेक्टर, गाँव, लैंडमार्क — English में',
    pincode: '6 अंकों का पिन कोड',
    city: 'पिन कोड से अपने आप भर जाएगा',
    state: 'पिन कोड से अपने आप भर जाएगा'
  };
  function field(id, label, ph, type, extra) {
    return '<div class="codf-f" id="f-' + id + '" data-f="' + id + '"><label for="cod-' + id + '">' + label + ' <i>*</i></label>'
      + (HINT[id] ? '<div class="h">' + HINT[id] + '</div>' : '')
      + '<div class="codf-in">' + svg(id, 'codf-fi') + '<input id="cod-' + id + '" name="' + id + '" type="' + type + '" placeholder="' + esc(ph) + '" ' + (extra || '') + '></div>'
      + '<div class="e" id="m-' + id + '"></div><div class="ok" id="ok-' + id + '"></div></div>';
  }
  function prodHtml() {
    var v = currentVariant() || {}; var t = totals();
    return (P && P.image ? '<img src="' + esc(P.image) + '" alt="">' : '')
      + '<div class="t">' + esc(P ? P.title : '') + (isTiered() ? '<div class="v">' + esc(v.title || '') + '</div>' : '') + '</div>'
      + '<div class="p">' + money(t.total) + '</div>';
  }
  function tiersHtml() {
    var vs = variants(); var h = '';
    if (isTiered()) {
      h += '<div class="codf-tiers">';
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i]; var save = (v.compare_at_price && v.compare_at_price > v.price) ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        h += '<div class="codf-tier' + (String(v.id) === String(state.variantId) ? ' on' : '') + (v.available === false ? ' codf-hide' : '') + '" data-vid="' + esc(v.id) + '">'
          + '<span><b>' + esc(v.title) + '</b>' + (i === 1 ? '<span class="codf-badge">Most popular</span>' : '') + (save ? '<small>Save ' + save + '%</small>' : '') + '</span>'
          + '<span style="text-align:right"><b>' + money(v.price) + '</b>' + (save ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</span></div>';
      }
      h += '</div>';
    } else {
      h += '<div style="margin:8px 0"><b>Quantity</b><span class="codf-qty"><button type="button" data-q="-1">&minus;</button><span>' + state.qty + '</span><button type="button" data-q="1">+</button></span></div>';
    }
    return h;
  }
  function summaryHtml() {
    var t = totals();
    return '<div class="codf-sum">'
      + (t.save ? '<div><span>Price</span><b><s>' + money(t.compare) + '</s></b></div><div><span>Offer price</span><b>' + money(t.subtotal) + '</b></div><div class="save"><span>Discount</span><b>-' + money(t.save) + '</b></div>'
                : '<div><span>Price</span><b>' + money(t.subtotal) + '</b></div>')
      + (t.discount ? '<div class="save"><span>Extra discount (' + esc(state.discountCode) + ')</span><b>-' + money(t.discount) + '</b></div>' : '')
      + '<div><span>Shipping</span><b>Free</b></div>'
      + '<div class="tot"><span>Total</span><b class="codf-tot">' + money(t.total) + '</b></div></div>';
  }
  function ctaText() { return esc(String(cfg.ctaForm || 'Complete My Purchase - {total}').replace('{total}', money(totals().total))); }
  function build() {
    var ov = document.createElement('div'); ov.className = 'codf-ov'; ov.id = 'cod-overlay';
    ov.innerHTML = '<div class="codf-m" role="dialog" aria-modal="true"><button type="button" class="codf-x" aria-label="Close">&times;</button>'
      + '<form class="codf-body" id="cod-body" novalidate autocomplete="on">'
      + '<div class="codf-prod" id="cod-prod">' + prodHtml() + '</div>'
      + '<div id="cod-tiers">' + tiersHtml() + '</div>'
      + '<div id="cod-summary">' + summaryHtml() + '</div>'
      + (cfg.trustLine ? '<div class="codf-h">' + esc(cfg.trustLine) + '</div>' : '')
      + (cfg.timerMinutes > 0 ? '<div class="codf-timer"><div style="font-size:15px">' + esc(cfg.timerText || '') + '</div><div class="codf-clock" id="cod-clock">' + pad2(cfg.timerMinutes) + ':00</div></div>' : '')
      + '<div class="codf-alert" id="cod-alert"></div>'
      + field('name', 'Full Name', 'Full Name', 'text', 'autocomplete="name"')
      + field('phone', 'Contact No.', 'Contact No. (10 digit mobile)', 'tel', 'autocomplete="tel" inputmode="numeric" maxlength="14"')
      + field('address1', 'Flat no./ House no./ Building/ Company/ Apartment', 'Flat no./ House no./ Building/ Company/ Apartment', 'text', 'autocomplete="address-line1"')
      + field('address2', 'Area, Street, Sector, Village', 'Area, Street, Sector, Village', 'text', 'autocomplete="address-line2"')
      + field('pincode', 'Postal code', '6 Digits [0-9] Pin Code', 'tel', 'autocomplete="postal-code" inputmode="numeric" maxlength="6"')
      + field('city', 'Town/City', 'Fills in from your pincode', 'text', 'autocomplete="address-level2" readonly tabindex="-1"')
      + field('state', 'State', 'Fills in from your pincode', 'text', 'autocomplete="address-level1" readonly tabindex="-1"')
      + '<div class="codf-hp"><label>Website</label><input type="text" name="website" tabindex="-1" autocomplete="off"></div>'
      + '<button type="submit" class="codf-cta" id="cod-submit">' + ctaText() + '</button>'
      + '</form></div>';
    document.body.appendChild(ov);
    els.overlay = ov; els.form = $('#cod-body', ov); els.body = els.form;
    on($('.codf-x', ov), 'click', close);
    on(ov, 'click', function (e) { if (e.target === ov) { close(); } });
    on(els.form, 'submit', submit);
    on(els.form, 'input', function (e) { if (e.target && e.target.name) { clearErr(e.target.name); } });
    on($('#cod-phone', ov), 'input', function (e) { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 14); onPhone(); });
    on($('#cod-pincode', ov), 'input', onPin);
    on($('#cod-tiers', ov), 'click', onTierClick);
    restore();
  }
  function refreshTiers() {
    var t = $('#cod-tiers'); if (t) { t.innerHTML = tiersHtml(); }
    var s = $('#cod-summary'); if (s) { s.innerHTML = summaryHtml(); }
    var p = $('#cod-prod'); if (p) { p.innerHTML = prodHtml(); }
    var b = $('#cod-submit'); if (b && !state.submitting) { b.innerHTML = ctaText(); }
    updateBar();
  }
  function onTierClick(e) {
    var t = e.target; while (t && t !== this && !t.getAttribute('data-vid') && !t.getAttribute('data-q')) { t = t.parentNode; }
    if (!t || t === this) { return; }
    if (t.getAttribute('data-vid')) { state.variantId = t.getAttribute('data-vid'); syncThemeVariant(); }
    else { state.qty = Math.min(Math.max(1, state.qty + parseInt(t.getAttribute('data-q'), 10)), cfg.maxQty || MAX_QTY); }
    refreshTiers();
  }
  function syncThemeVariant() {
    var v = currentVariant(); if (!v) { return; }
    var tile = null; $$('.lure-tile').forEach(function (t) { if (t.getAttribute('data-title') === v.title) { tile = t; } });
    if (tile) { try { tile.click(); } catch (e) { } }
    var inp = $('form[action*="/cart/add"] input[name="id"]'); if (inp) { inp.value = v.id; }
  }
  function startTimer() {
    if (!(cfg.timerMinutes > 0)) { return; }
    clearInterval(state.tick);
    var end = lsGet('cod_timer_end'); if (!end || end < Date.now()) { end = Date.now() + cfg.timerMinutes * 60000; lsSet('cod_timer_end', end); }
    function tickf() {
      var c = $('#cod-clock'); if (!c) { return; }
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000)); c.textContent = pad2(Math.floor(s / 60)) + ':' + pad2(s % 60);
      if (s <= 0) { end = Date.now() + cfg.timerMinutes * 60000; lsSet('cod_timer_end', end); }
    }
    tickf(); state.tick = setInterval(tickf, 1000);
  }

  /* ---------------- validation (customer copy, field level) ---------------- */
  function setErr(f, msg) { var w = $('#f-' + f); var m = $('#m-' + f); if (w) { w.className = 'codf-f err'; } if (m) { m.textContent = msg; } }
  function clearErr(f) { var w = $('#f-' + f); if (w && /err/.test(w.className)) { w.className = 'codf-f'; } }
  function setOk(f, msg) { var w = $('#f-' + f); var m = $('#ok-' + f); if (w) { w.className = 'codf-f good'; } if (m) { m.textContent = msg; } }
  function val(f) { var i = $('#cod-' + f); return i ? i.value : ''; }
  function cleanPhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 12 && d.slice(0, 2) === '91') { d = d.slice(2); }
    if (d.length === 11 && d.charAt(0) === '0') { d = d.slice(1); }
    return d;
  }
  function validate() {
    var ok = true; var first = null;
    function bad(f, m) { setErr(f, m); ok = false; if (!first) { first = f; } }
    var name = val('name').replace(/\s+/g, ' ').replace(/^\s|\s$/g, '');
    if (name.length < 2) { bad('name', 'Please enter your full name'); }
    else if (!isAscii(name)) { bad('name', 'Please type your name in English letters only, no Hindi or other languages'); }
    var ph = cleanPhone(val('phone'));
    if (ph.length !== 10) { bad('phone', 'Please enter a 10 digit mobile number'); }
    else if (!/^[6-9]/.test(ph)) { bad('phone', 'Mobile number should start with 6, 7, 8 or 9. Please recheck'); }
    var a1 = val('address1').replace(/\s+/g, ' ').replace(/^\s|\s$/g, ''); var a2 = val('address2').replace(/\s+/g, ' ').replace(/^\s|\s$/g, '');
    if (a1.length < 3) { bad('address1', 'Please enter your flat / house number and building'); }
    else if (!isAscii(a1)) { bad('address1', 'Please type the address in English letters only, no Hindi or other languages'); }
    if (a2.length < 3) { bad('address2', 'Please enter your area, street or village'); }
    else if (!isAscii(a2)) { bad('address2', 'Please type the address in English letters only, no Hindi or other languages'); }
    else if (a1.length + a2.length < 10) { bad('address2', 'Please add a little more detail to your address so the courier can find you'); }
    var pin = val('pincode').replace(/\D/g, '');
    if (pin.length !== 6) { bad('pincode', 'Pincode should be 6 digits. Please recheck'); }
    else if (state.pinOk === false) { bad('pincode', 'We could not find this pincode. Please recheck'); }
    if (first) { var el = $('#cod-' + first); if (el) { try { el.focus(); el.scrollIntoView({ block: 'center' }); } catch (e) { } } }
    return ok ? { name: name, phone: ph, address1: a1, address2: a2, pincode: pin } : null;
  }

  /* ---------------- phone / pincode live behaviour ---------------- */
  var abandonSent = false;
  function onPhone() {
    var ph = cleanPhone(val('phone'));
    if (ph.length === 10 && /^[6-9]/.test(ph) && !abandonSent) {
      abandonSent = true;
      xhr('POST', API + '/cod/abandon', { shop: SHOP, phone: ph, name: val('name'), handle: P ? P.handle : '', url: window.location.href, device: deviceId() }, function () { });
    }
  }
  function onPin() {
    var pin = val('pincode').replace(/\D/g, ''); state.pinOk = null;
    $('#cod-city').value = ''; $('#cod-state').value = '';
    var w = $('#f-pincode'); if (w) { w.className = 'codf-f'; }
    if (pin.length !== 6) { return; }
    $('#cod-city').value = '...';
    xhr('GET', API + '/cod/pincode/' + pin, null, function (st, j) {
      if (val('pincode').replace(/\D/g, '') !== pin) { return; }
      if (st === 200 && j && j.city) {
        state.pinOk = true; $('#cod-city').value = j.city; $('#cod-state').value = j.state;
        setOk('pincode', '✓ Delivery available to ' + j.city + ', ' + j.state);
      }
      else if (st === 404 || st === 400) { state.pinOk = false; $('#cod-city').value = ''; setErr('pincode', (j && j.detail) || 'We could not find this pincode. Please recheck'); }
      else { state.pinOk = null; $('#cod-city').value = ''; }
    }, 12000);
  }

  /* ---------------- autofill ---------------- */
  function restore() {
    var s = lsGet(LS_KEY); if (!s) { return; }
    ['name', 'phone', 'address1', 'address2', 'pincode'].forEach(function (k) { var i = $('#cod-' + k); if (i && s[k] && !i.value) { i.value = s[k]; } });
    if (s.pincode) { onPin(); }
  }
  function remember(c) { lsSet(LS_KEY, { name: c.name, phone: c.phone, address1: c.address1, address2: c.address2, pincode: c.pincode }); }

  /* ---------------- submit ---------------- */
  function showAlert(msg) { var a = $('#cod-alert'); if (a) { a.textContent = msg; a.style.display = msg ? 'block' : 'none'; } }
  function submit(e) {
    if (e) { e.preventDefault(); }
    if (state.submitting) { return; }
    showAlert('');
    var c = validate(); if (!c) { return; }
    var v = currentVariant(); if (!v) { showAlert('Please reload the page and try again'); return; }
    state.submitting = true; var btn = $('#cod-submit'); btn.disabled = true; btn.textContent = 'Placing your order...';
    if (!state.submitId) { state.submitId = uid(); }
    state.lastSubmitId = state.submitId;
    var payload = {
      shop: SHOP, submit_id: state.submitId, handle: P.handle, variant_id: parseInt(v.id, 10), quantity: isTiered() ? 1 : state.qty,
      name: c.name, phone: c.phone, address1: c.address1, address2: c.address2, pincode: c.pincode,
      city: val('city'), state: val('state'), fill_seconds: Math.round((Date.now() - state.openedAt) / 1000),
      url: window.location.href, utm: getUtm(), device: deviceId(), website: $('input[name="website"]', els.form).value || '',
      event_id: state.submitId, discount_code: state.discountCode || null, fbp: cookie('_fbp'), fbc: cookie('_fbc'),
      scid: cookie('_scid'), sccid: getScCid()
    };
    remember(c);
    xhr('POST', API + '/cod/order', payload, function (st, j) {
      state.submitting = false; btn.disabled = false; btn.innerHTML = ctaText();
      if (st === 200 && j && j.ok) { success(j, c); return; }
      if (st === 422 && j && j.field) { setErr(j.field, j.message); var el = $('#cod-' + j.field); if (el) { try { el.focus(); } catch (x) { } } return; }
      if (st === 409 && j && j.blocked) { showBlocked(j.message); return; }
      if (st >= 400 && st < 500 && j && j.detail) { showAlert(j.detail); return; }
      outboxAdd(payload);
      showAlert('Slow network. Your order is saved on this phone and will be sent automatically. You can also tap the button again.');
    }, 30000);
  }
  function success(j, c) {
    var t = totals(); state.done = true; clearInterval(state.tick);
    lsSet(LAST_ORDER_KEY, { ts: Date.now(), name: j.order_name || '' });
    outboxRemove(j.event_id || state.submitId);
    if (state.discountCode) { state.downsellUsed = true; }
    var addr = c.address1 + ', ' + c.address2 + ', ' + val('city') + ', ' + val('state') + ' - ' + c.pincode;
    if (j.status_url && /^https:\/\//.test(j.status_url)) {
      /* Standard Shopify thank-you (order status) page: fire the Purchase pixel, then redirect. */
      var pd0 = contentData(); pd0.value = t.total / 100; pd0.order_id = j.order_name || '';
      if ((cfg.snapPixels || []).length && window.snaptr) { loadSnap({ user_phone_number: '+91' + c.phone }); }
      track('Purchase', pd0, j.event_id || state.lastSubmitId);
      els.body.innerHTML = '<div class="codf-ty"><h3><strong>Order placed! Taking you to your order page...</strong></h3><p>Order Number: ' + esc(j.order_name || '') + '</p></div>';
      setTimeout(function () { window.location.href = j.status_url; }, 600);
      return;
    }
    els.body.innerHTML = '<div class="codf-ty"><h3><strong>Thank you for shopping with us, ' + esc(c.name) + '!</strong></h3>'
      + '<h3><span lang="hi">हमारे साथ खरीदारी करने के लिए धन्यवाद!</span></h3>'
      + '<p>Here are your order details.</p><h4><span lang="hi">यहां आपके ऑर्डर का विवरण दिया गया है.</span></h4>'
      + '<ul><li>Order Number: ' + (j.order_name ? esc(j.order_name) : 'will be sent on WhatsApp / SMS') + '</li><li>Product: ' + esc(P.title) + (isTiered() ? ' (' + esc((currentVariant() || {}).title || '') + ')' : '') + '</li><li>Contact Number: ' + esc(c.phone) + '</li><li>Delivery Address: ' + esc(addr) + '</li><li>Order Total: INR ' + esc(String(Math.round(t.total) / 100)) + '</li></ul>'
      + '<p>Your order will be delivered to you in <strong>4-5 business days</strong>. Kindly accept the delivery &amp; <strong>keep the exact amount of cash ready</strong>. Never give OTP to your delivery person while on a call.</p>'
      + '<p>We will call or WhatsApp you to confirm.</p>'
      + '<button type="button" class="codf-cta" id="cod-ty-close">Continue shopping</button></div>';
    on($('#cod-ty-close'), 'click', function () { window.location.href = '/'; });
    state.submitId = null;
    var bar = $('#cod-bar'); if (bar) { bar.className = 'codf-sticky'; }
    try { window.scrollTo(0, 0); $('.codf-m', els.overlay).scrollTop = 0; els.overlay.scrollTop = 0; } catch (e) { }
    var pd = contentData(); pd.value = t.total / 100; pd.order_id = j.order_name || '';
    if ((cfg.snapPixels || []).length && window.snaptr) { loadSnap({ user_phone_number: '+91' + c.phone }); }
    track('Purchase', pd, j.event_id || state.lastSubmitId);
  }

  /* ---------------- repeat block ---------------- */
  function showBlocked(msg) {
    lsSet(LAST_ORDER_KEY, { ts: Date.now(), name: '' }); state.done = true; clearInterval(state.tick);
    els.body.innerHTML = '<div class="codf-ty"><h3><strong>Thank you!</strong></h3><p>' + esc(msg || cfg.repeatBlockMessage) + '</p>'
      + '<button type="button" class="codf-cta" id="cod-ty-close">Continue shopping</button></div>';
    on($('#cod-ty-close'), 'click', function () { window.location.href = '/'; });
  }
  function recentlyOrdered() {
    var l = lsGet(LAST_ORDER_KEY); var days = cfg.repeatBlockDays || 0;
    return !!(l && l.ts && days > 0 && (Date.now() - l.ts) < days * 86400000);
  }

  /* ---------------- client outbox ---------------- */
  function outboxAdd(payload) {
    var q = lsGet(OUTBOX_KEY) || []; var out = [];
    for (var i = 0; i < q.length; i++) { if (q[i].submit_id !== payload.submit_id) { out.push(q[i]); } }
    out.push(payload); while (out.length > 5) { out.shift(); }
    lsSet(OUTBOX_KEY, out);
  }
  function outboxRemove(id) {
    var q = lsGet(OUTBOX_KEY) || []; var out = [];
    for (var i = 0; i < q.length; i++) { if (q[i].submit_id !== id) { out.push(q[i]); } }
    lsSet(OUTBOX_KEY, out);
  }
  function outboxFlush() {
    var q = lsGet(OUTBOX_KEY) || []; if (!q.length || !API) { return; }
    var i = 0;
    function next() {
      if (i >= q.length) { return; }
      var item = q[i++]; item.outbox_retry = (item.outbox_retry || 0) + 1;
      xhr('POST', API + '/cod/order', item, function (st, j) {
        if (st >= 200 && st < 500) { outboxRemove(item.submit_id); if (st === 200 && j && j.ok) { lsSet(LAST_ORDER_KEY, { ts: Date.now(), name: j.order_name || '' }); } }
        else if (item.outbox_retry >= 20) { outboxRemove(item.submit_id); }
        else { outboxAdd(item); }
        next();
      }, 20000);
    }
    next();
  }

  /* ---------------- downsell on close ---------------- */
  function maybeDownsell() {
    if (state.downsellShown || state.downsellUsed || state.done || !(cfg.downsellAmount > 0) || !cfg.downsellCode) { return false; }
    if (lsGet('cod_downsell_seen')) { return false; }
    state.downsellShown = true; lsSet('cod_downsell_seen', 1);
    var amt = money(cfg.downsellAmount * 100);
    els.body.innerHTML = '<div class="codf-ds"><div class="badge">' + amt + '</div><h3>Get ' + amt + ' Discount!</h3>'
      + '<p>Congratulations! You have unlocked a one-time <b>' + amt + ' discount</b> on this order.</p>'
      + '<p>Complete your Cash on Delivery order now to claim it.</p>'
      + '<button type="button" class="ok" id="cod-ds-yes">Complete order with ' + amt + ' OFF</button>'
      + '<button type="button" class="no" id="cod-ds-no">No thanks, close</button></div>';
    els.overlay.className = 'codf-ov on'; document.body.className += ' codf-lock'; state.open = true;
    on($('#cod-ds-yes'), 'click', function () { state.discountCode = cfg.downsellCode; rebuildForm(); showInfo(amt + ' discount applied. Complete the form to claim it.'); });
    on($('#cod-ds-no'), 'click', function () { state.done = false; forceClose(); });
    return true;
  }
  function rebuildForm() {
    var ov = els.overlay; if (ov && ov.parentNode) { ov.parentNode.removeChild(ov); }
    els.overlay = null; build(); els.overlay.className = 'codf-ov on'; refreshTiers(); startTimer();
  }
  function showInfo(msg) {
    var old = $('#cod-info'); if (old) { old.parentNode.removeChild(old); }
    var el = document.createElement('div'); el.className = 'codf-info'; el.id = 'cod-info'; el.textContent = msg;
    var f = $('#cod-summary'); if (f && f.parentNode) { f.parentNode.insertBefore(el, f.nextSibling); }
  }

  /* ---------------- open / close ---------------- */
  function open() {
    if (!els.overlay) { build(); }
    if (recentlyOrdered() && !state.done) { showBlocked(cfg.repeatBlockMessage); }
    readThemeVariant(); if (!state.done) { refreshTiers(); startTimer(); }
    state.openedAt = state.openedAt || Date.now();
    els.overlay.className = 'codf-ov on'; document.body.className += ' codf-lock'; state.open = true;
    var bar = $('#cod-bar'); if (bar) { bar.className = 'codf-sticky'; }
    if (!state.icSent) { state.icSent = true; track('InitiateCheckout', contentData()); }
    var n = $('#cod-name'); if (n && !n.value) { setTimeout(function () { try { n.focus(); } catch (e) { } }, 50); }
  }
  function forceClose() {
    els.overlay.className = 'codf-ov'; document.body.className = document.body.className.replace(/\s*codf-lock/g, ''); state.open = false;
    clearInterval(state.tick);
  }
  function close() {
    if (!els.overlay) { return; }
    if (!state.done && maybeDownsell()) { return; }
    forceClose();
  }

  /* ---------------- theme hijack ---------------- */
  function buyButtonHtml() {
    return svg('cart', 'codf-ico') + esc(cfg.cta) + (cfg.ctaSub ? '<small>' + esc(cfg.ctaSub) + '</small>' : '');
  }
  function hijack() {
    var form = $('form[action*="/cart/add"]'); if (!form) { return false; }
    $$('.shopify-payment-button, accelerated-checkout, .accelerated-checkout, [data-shopify="payment-button"]').forEach(function (b) { b.className += ' codf-hide'; });
    var native = $('button[name="add"], .add-to-cart-button, [data-testid="standalone-add-to-cart"]', form) || $('button[type="submit"]', form);
    var b = document.createElement('button'); b.type = 'button'; b.className = 'codf-btn'; b.innerHTML = buyButtonHtml();
    on(b, 'click', function (e) { e.preventDefault(); e.stopPropagation(); open(); });
    var wrap = native ? (native.closest ? (native.closest('add-to-cart-component') || native) : native) : null;
    if (wrap && wrap.parentNode) { wrap.parentNode.insertBefore(b, wrap); wrap.className += ' codf-hide'; }
    else { form.appendChild(b); }
    $$('button[name="add"], .add-to-cart-button', form).forEach(function (x) { x.className += ' codf-hide'; });
    els.inlineBtn = b;
    on(form, 'submit', function (e) { e.preventDefault(); e.stopPropagation(); open(); }, true);
    on(document, 'click', function (e) {
      var t = e.target; while (t && t !== document) { if (/(^|\s)lure-tile(\s|$)/.test(t.className || '')) { setTimeout(function () { readThemeVariant(); updateBar(); }, 50); break; } t = t.parentNode; }
    }, true);
    return true;
  }
  function updateBar() {
    var bar = $('#cod-bar'); if (!bar) { return; }
    var t = totals(); var v = currentVariant();
    $('.codf-sp', bar).innerHTML = '<span>' + esc((P.title || '').slice(0, 48)) + (v && isTiered() ? ' · ' + esc(v.title) : '') + '</span><b>' + money(t.total) + '</b>';
  }
  function buildBar() {
    var bar = document.createElement('div'); bar.id = 'cod-bar'; bar.className = 'codf-sticky';
    bar.innerHTML = '<div class="codf-sp"></div><button type="button" class="codf-btn">' + buyButtonHtml() + '</button>';
    document.body.appendChild(bar); on($('button', bar), 'click', open);
    function check() {
      if (state.open) { bar.className = 'codf-sticky'; return; }
      var r = (els.inlineBtn || $('form[action*="/cart/add"]')).getBoundingClientRect(); var show = r.bottom < 0 || r.top > window.innerHeight;
      bar.className = show ? 'codf-sticky on' : 'codf-sticky';
    }
    on(window, 'scroll', check); on(window, 'resize', check); updateBar(); check(); setInterval(check, 800);
  }

  /* ---------------- boot ---------------- */
  function boot() {
    try { getScCid(); } catch (e) { }
    if (API) { try { outboxFlush(); } catch (e) { } }
    if (!P || !P.handle || !API) { return; }
    xhr('GET', API + '/cod/config/' + encodeURIComponent(SHOP), null, function (st, j) {
      if (st === 200 && j) { for (var k in j) { if (j.hasOwnProperty(k)) { cfg[k] = j[k]; } } }
      injectStyles();
      readThemeVariant();
      if (hijack()) { buildBar(); }
      langSwitcher();
      loadPixels(); track('ViewContent', contentData());
    }, 8000);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();